import React from 'react'

function SvgInfoPerso() {
  return (
    <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.9995 18.5L16.9997 15.5003C16.9999 13.8433 15.6567 12.5 13.9997 12.5H6.00034C4.34361 12.5 3.00052 13.8429 3.00034 15.4997L3 18.5M13 5.5C13 7.15685 11.6569 8.5 10 8.5C8.34314 8.5 7 7.15685 7 5.5C7 3.84315 8.34314 2.5 10 2.5C11.6569 2.5 13 3.84315 13 5.5Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
  )
}

export default SvgInfoPerso